<template>
  <div class="clickable" @click="$emit('open', data)">
    <div class="card relative image">
      <img class='absolute' :src='data.img'>
      <div class="absolute gradient"/>
      <div class="absolute gradient2"/>
      <span class="text"> {{data.title}} </span>
      <div v-if="data['categories']" class="category absolute text"> 
        <img v-for="category in data.categories" :key="category" :src="publicIcon+category+'.svg'"> </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data(){
    return {
      publicIcon: process.env.BASE_URL+'svg/'
    }
  },
  computed: {
    category(){
      if(this.data['category'])
        return this.data.category
      else 
        return null
    }
  }
}
</script>

<style scoped>

.relative{
  position: relative;
}

.absolute.category {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;

}

.category *{
  width: 50px;
  height: 30px;
  padding: 2px;
  border-radius: 25%;
}

.card{
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0px 2px 5px #0005;
  display: flex !important;
  flex-direction: row;
  align-items: flex-end;
  pointer-events: none;
  user-select: none;
}

.card *{
  pointer-events: none;
  
}


.clickable{
  cursor: pointer;
  pointer-events: auto;
}

.clickable .card{
  transform: scale(1.0,1.0);
  background: var(--dark-color);

  box-shadow: var(--dark-color) 0px 0px 5px;
  transition: transform 0.1s ease-out, box-shadow 0.1s ease-out;

}

.clickable:hover .card{
  box-shadow: var(--dark-color) 0px 0px 15px;
  transform: scale(1.05,1.05);
}

@keyframes hover {
  0%{
    transform: scale(1.0,1.0);
  }
  /* 40%{
    transform: scale(0.95,0.95);
  } */
  100%{
    transform: scale(1.05,1.05);
  }
}


.gradient{
  background: linear-gradient(0deg, var(--dark-color) -10%, var(--dark-color2) 40%);
  z-index: 1;
}
.gradient2{
  background: linear-gradient(180deg, var(--dark-color) -60%, var(--dark-color2) 40%);
  z-index: 1;
}

.image{
  height: 300px;
}

.image img{
  object-fit: cover;
  height: 100%;
}


.text{
  color: white;
  width: 100%;
  margin-bottom: 0.5em;
  font-size: 1.5em;
  z-index: 1;
}

.absolute{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

</style>
